<template xmlns:v-popover="">
    <div class="home-head">
        <div class="arm-logo">
            <div class="arm-logo-wrapper">
                <img class="img" src="../assets/logo_bzzx.png"/>
                <a href="https://lcloud.longene.com.cn" target="_blank"><img class="img" src="../assets/logo_hmysj.png"/></a>
                <div class="search-area">
                    <el-input size="small" placeholder="请输入搜索关键字" v-model="searchKey"
                              @focus="focus"
                              @blur="blur"
                              @keyup.enter.native="searchHandler"
                              style="width: 300px;">
                        <!--<el-button slot="append" icon="el-icon-search" @click="searchHandler"></el-button>-->
                    </el-input>
                    <div
                            @mouseenter="enterSearchBoxHanlder"
                            v-if="isSearchList"
                            id="search-box"
                    >
                        <div v-if="isSearchList" class="result-area">
                            <div v-for="search in searchList" class="result-box" v-if="searchList.length > 0" @click="goToSearchPage(search)">
                                <span class="result-item" v-html="showSearchContent(search.likeStr, search.likeContent)"></span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopBar",
        components: {},
        data() {
            return {
                searchKey: "", //当前输入框的值
                isFocus: false, //是否聚焦
                searchList: [], //搜索返回数据,
            }
        },
        watch: {
            'searchKey': {
                handler: function () {
                    this.searchHandler()
                }
            }
        },
        computed: {
            isSearchList() {
                return this.isFocus && this.searchKey.length > 0;
            },
        },
        filters: {

        },
        methods: {
            showSearchContent(likeStr, content) {
                // console.log("showSearchContent " + likeStr + ", " + content)
                const reg = new RegExp(this.searchKey, 'ig')
                var titleResult = likeStr.replace(reg, (val) => {
                    return `<span style="background: #f0ff26">${val}</span>`
                })
                var contentResult = content.replace(reg, (val) => {
                    return `<span style="background: #f0ff26">${val}</span>`
                })
                if (contentResult.length > 0) {
                    return titleResult + ">" + contentResult
                } else {
                    return titleResult
                }
            },
            focus() {
                this.isFocus = true;
            },
            blur() {
                var self = this;
                this.searchBoxTimeout = setTimeout(function () {
                    self.isFocus = false;
                }, 300);
            },
            enterSearchBoxHanlder() {
                clearTimeout(this.searchBoxTimeout);
            },
            searchHandler() {
                if (this.searchKey.length > 0) {
                    this.$get("/butane/global/search/menuOrArticle", {content: this.searchKey}).then(res => {
                        if (res.success) {
                            // console.log("res is ")
                            // console.log(res)
                            let result = res.data
                            let list = []
                            if (result.length > 0) {
                                result.forEach(item => {
                                    item.likeStr = item.likeStr.trim()
                                    list.push(item)
                                })
                            }
                            this.searchList = list
                        }
                    })
                }
            },
            closeHandler(search) {
                clearTimeout(this.searchBoxTimeout);
            },
            goToSearchPage(search) {
                let searchWord = this.searchKey
                this.searchKey = ""
                this.$emit("search", search.link, searchWord)
            }
        },
        mounted() {
        }
    };
</script>

<style lang="less" scoped>
    .home-head {
        background-color: #252a2f;
        height: 50px;
        width: 100%;
        left: 0;
        top: 0;
        position: fixed;
        z-index: 1000 !important;
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: space-between;
        .arm-logo {
            margin-left: 20px;
            height: 50px;
            /*float: left !important;*/
            .arm-logo-wrapper {
                min-width: 500px !important;
                float: left !important;
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                /*background-color: red;*/
                .img {
                    height: 50px;
                    width: 166px;
                }
                a {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .img {
                        height: 50px;
                        width: 187px;
                    }
                }
                .sys-link {
                    color: #fff;
                    font-size: 24px;
                    line-height: 50px;
                    margin-left: 10px;
                    /*margin-right: 1px;*/
                    /*padding: 0 12px;*/
                    text-align: center;
                    text-decoration: none;
                    font-family: 微软雅黑;
                    width: 250px;
                    /*span {*/
                    /*padding: 0 12px;*/
                    /*}*/
                }
            }
        }
    }

    .search-area {
        width: 360px;
        margin-left: 60px;
        position: relative;
        /*background-color: red;*/
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
    }

    #search-box {
        position: absolute;
        top: 40px;
        let: 0;
        width: 300px;
        max-height: 200px;
        min-height: 40px;
        border: 1px solid #eee;
        background-color: white;
        overflow-y: scroll;
        font-size: 14px;
        color: #888;
    }

    .result-area {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .result-box {
        width: 100%;
        height: 40px;
        padding-left: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .result-box:hover{
        background-color: #eee;
        color: #3f69e0;
    }
    .result-item{
        width: 280px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        text-align: left;
    }
</style>
